<template>
    <v-container py-1>
        <v-layout wrap>
            <v-flex xs12>

                <h2 class="title font-weight-regular mb-2">Selecciona {{clientLabel.toLowerCase()}}</h2>

                <v-divider class="py-2"></v-divider>

                <v-layout wrap>

                    <!--Main client-->
                    <v-flex xs12 mt-3>

                        <client-picker
                                v-if="!user"
                                :label="`RUT del ${clientLabel.toLowerCase()}`"
                                :internal="internal"
                                :provider-id="providerId"
                                :requiredFields="requiredFields"
                                :requestedFields="requestedFields"
                                @change="user = $event" />

                        <client-card-item
                                @remove="user = null"
                                :label="`${clientLabel}`"
                                v-else
                                :internal="internal"
                                :client="user" />

                    </v-flex>

                    <v-flex xs12 my-0>

                        <template>

                            <client-card-item
                                    v-for="(companion, index) in companions"
                                    :key="companion.id"
                                    @remove="companions.splice(index, 1)"
                                    label="Acompañante"
                                    :internal="internal"
                                    :client="companion" />

                            <client-picker
                                    label="RUT de acompañante (opcional)"
                                    :internal="internal"
                                    :provider-id="providerId"
                                    :requiredFields="requiredFields"
                                    :requestedFields="requestedFields"
                                    @change="onParticipantChange" />

                        </template>

                    </v-flex>

                </v-layout>

            </v-flex>
        </v-layout>
    </v-container>


</template>

<script>

    import {getLabel} from '@/utils/Institution'

    import { mapMutations } from 'vuex'

    import ClientPicker from '@/components/appointments/steps/ClientPicker'
    import ClientCardItem from '@/components/appointments/steps/ClientCardItem'
    import AppointmentConfigMixin from "@/mixins/AppointmentConfigMixin";

    export default{
        components:{
            ClientCardItem,
            ClientPicker
        },
        mixins: [AppointmentConfigMixin],
        props:{
            internal: {
                type: Boolean,
                default: false
            },
            requiredFields:{
                type: Array
            },
            requestedFields:{
                type: Array
            },
            providerId: {
              type: Number
            }
        },
        data(){
            return {
                dialog: false,
                user: null,
                companions: []
            }
        },
        mounted(){
          const vm = this
          vm.setDefaultClients()
        },
        methods:{
            ...mapMutations(['showSnackBar']),
            onParticipantChange(user){

                if(!user) return

                var vm = this
                const existing = vm.companions.find(usr => user.id === usr.id)
                if(existing || user.id === vm.user.id){
                    vm.showSnackBar({
                        text: `Este ${vm.clientLabel.toLowerCase()} ya está en el listado`
                    })
                    return
                }

                vm.companions.push(user)

            },
        },
        computed:{
            clientLabel(){
                return getLabel('commons.client.singular')
            },
            companionsMap(){

                var vm = this

                const map = vm.companions.map(companion => {
                    return {
                        id: companion.id,
                        relationship: 'other'
                    }
                })

                return map

            },
            config(){
                var vm = this
                return {
                    user_id: vm.user && vm.user.id || null,
                    companions: vm.companionsMap
                }
            },
            valid(){

                var vm = this
                if(!vm.user) return false

                return true

            }
        },
        watch:{
            valid(val){
                this.$emit('valid', val)
            },
            config(val){
                this.$emit('change', val)
            }
        }
    }
</script>
